<template>
  <el-form-item class="rc-ocr-runtime"
                :class="[component.properties.sortType==='toTop'&& 'to-top',component.properties.sortType==='hidden'&& 'hidden']"
                ref="uploadForm"
                :label-width="labelParameter.width">
    <div v-if="labelParameter.showSlot"
         :class="['control-label', labelParameter.className]"
         slot="label"
         :title="component.name">{{labelParameter.labelName}}</div>
    <span v-else slot="label" :title="component.name">{{ labelParameter.labelName }}</span>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <el-upload
      v-if="!disabled"
      ref="uploadControl"
      class="rc-ocr-control"
      name="files"
      :disabled="uploading"
      :action="getUrl()"
      :headers="headers"
      :multiple="true"
      list-type="picture"
      :before-upload="beforeUpload"
      :on-success="updateFile"
      :on-error="uploadFailed"
      :show-file-list="false"
      :data="dataType"
      :auto-upload="false"
      :on-change="fileChange">
      <el-button v-if="!uploading" class="upload-button" type="text">请选择</el-button>
      <span v-else style="color: #62a8f2"><i class="el-icon-loading"></i>识别中</span>
    </el-upload>
    <!-- 文件上传提示 -->
    <el-dialog v-if="dialogParams.visable"
               class="rc-ocr-dialog"
               title="附件上传提示"
               :visible.sync="dialogParams.visable"
               :width="dialogParams.width"
               append-to-body center
               :close-on-click-modal="false"
               :top="dialogParams.type === 'hint' ? '28vh' : '20vh'"
               @close="cancel">
      <div v-if="dialogParams.type === 'hint'" class="hint" v-html="dialogParams.hint"></div>
      <div v-else class="file-select-list">
        <div class="title">
          <div class="left">文件名</div>
          <div class="right">大小</div>
        </div>
        <div class="file-content">
          <div :class="['item', item.checked && 'checked-item']" v-for="(item, i) in getFileList" :key="i">
            <div class="left file-name">
              <span :class="['name', item.size >= maxSize && 'name-hint']" :title="item.name">
                <el-checkbox :disabled="item.size >= maxSize" v-model="item.checked">{{item.name}}</el-checkbox>
              </span>
              <span v-if="item.size >= maxSize" style="color: red;">(超过50M限制)</span>
            </div>
            <div class="right size">{{ getFileSize(item.size) }}</div>
          </div>
        </div>
        <!-- 这玩意不需要四舍五入 -->
        <div class="file-footer">已选择{{ Math.floor(getSelectSize * 100) / 100 }}M，可以上传（有{{ getNoUploadFile }}个不能上传）</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div v-if="dialogParams.type === 'hint'" class="hint-button">
          <el-button @click="cancel">确定</el-button>
        </div>
        <div v-else class="select-file">
          <el-button @click="save" type="primary">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </span>
    </el-dialog>
  </el-form-item>
</template>

<script>
import {componentMixin, inputMixin} from './mixins'
import tokenStorage from '@/plugins/tokenStorage'
import {findVueMixin} from './findVue'
import moment from 'moment'

export default {
  name: 'rc-ocr',
  mixins: [componentMixin, inputMixin, findVueMixin],
  props: ['component', 'value', 'index', 'labelParameter', 'disabled'],
  inject: ['dataService', 'initState'],
  data () {
    let maxSize = 6
    maxSize = maxSize * 1024 * 1024
    return {
      updateIndex: 0,
      isTableComponent: false,
      fileList: [],
      headers: {'Authorization': tokenStorage.getToken()},
      dataType: {type: 'USER'},
      uploading: false,
      url: '/shared-api/ocr/generalBasicOcr',
      fileLists: [],
      targetComponent: null,
      timeOut: null,
      dialogParams: {
        visable: false,
        width: '398px',
        type: 'hint',
        hint: ''
      },
      maxSize: maxSize,
      selectFileList: {
        list: [],
        selected: []
      },
      isUpload: false
    }
  },
  mounted () {
    // 所有控件初始化之后initState.state会改为true
    let unWatch = this.$watch(() => { return this.initState.state }, (val) => {
      if (val) {
        // 初始化时通过归档id拿到要更新的的对象的实例,只执行一次
        if (this.component.properties.ocr.rules && this.component.properties.ocr.rules.originFileId) {
          // originFileId 扫描原件对应控件归档
          let originFileId = this.component.properties.ocr.rules.originFileId
          if (originFileId.includes('+')) {
            this.isTableComponent = true
            // 含表格tableId 说明选的是表格内情况
            let tableId = originFileId.split('+')[0]
            this.targetComponent = this.findAllVueByChildren(this).find(e => e.component && e.component.archive.tableId === tableId)
            // 判断是新建还是修改,如果是修改需要更改初始updateIndex的值
            if (this.dataService.data.dataState !== 'create') {
              this.updateIndex = this.targetComponent.value && this.targetComponent.value.length
            }
          } else {
            this.targetComponent = this.findAllVueByChildren(this).find(e => e.component && e.component.archive.columnId === originFileId)
          }
        }
        unWatch()
      }
    })
  },
  methods: {
    fileChange (file, fileList) {
      if (file && file.status === 'ready') {
        let self = this
        if (self.timeOut) {
          clearTimeout(self.timeOut)
        }
        this.timeOut = setTimeout(() => {
          let list = fileList.filter(f => f.size >= self.maxSize)
          if (list && list.length > 0) {
            if (fileList.filter(f => f && f.status === 'ready').length === 1) {
              let hint = `您选择的文件不能上传，原因如下:<br><span title="${file.name}" class="file-name">${file.name}</span><span style="color: red">(超过6M限制)</span>`
              this.openDialog({visable: true, width: '398px', type: 'hint', hint})
            } else {
              this.selectFileList.list = fileList
              let fl = this.$_.cloneDeep(fileList)
              // 加上是否勾选标识
              fl.forEach(f => { f.checked = f.size < self.maxSize })
              this.selectFileList.selected = fl
              this.openDialog({visable: true, width: '430px', type: 'select'})
            }
          } else {
            // 多选的时候也是发送多次http请求一张一张的传
            self.$refs.uploadControl.submit()
          }
        }, 10)
      }
    },
    beforeUpload (file) {
      // 如果表格数据没build完先不让上传
      if (this.updateIndex === undefined) {
        return this.$message.info('加载中, 请稍候再试')
      }
      if (!this.isUpload) {
        this.isUpload = true
      }
      let type = file.name.split('.').pop()
      // 只允许上传图片
      let allowType = ['png', 'jpg', 'jpeg', 'bmp', 'pdf']
      if (!allowType.some(n => n === type.toLocaleLowerCase())) {
        this.$message.warning('仅支持png,jpg,jpeg,bmp格式的图片和pdf文件')
        return false
      }
      this.uploading = true
      this.fileLists.push({name: file.name, url: file.uid, loading: true, file})
    },
    uploadFailed (err, file, fileList) {
      let i = this.fileLists.findIndex(f => f.url === file.uid)
      i !== -1 && this.fileLists.splice(i, 1)
      if (this.fileLists.length === 0) {
        this.uploading = false
      }
      if (err.status === 400) {
        this.$message.error(`${file.name} 图片识别失败，请重新上传`)
      } else {
        this.$message.error(`${file.name} 上传失败`)
      }
      throw new Error(err)
    },
    updateFile (res, file, fileList) {
      let name = res[0] ? res[0].file : ''
      let url = res[0] ? res[0].dir : ''
      // 获取识别到的内容
      let content = this.getContent(res)
      // 上传完的就从数组中拿掉
      this.fileLists = this.fileLists.filter(f => f.url !== file.uid)
      if (this.fileLists.length === 0) {
        this.uploading = false
      }
      if (!content) {
        let message = ''
        switch (this.component.properties.ocr.type) {
          case 'text':message = `${file.name}未检测到文字`; break
          case 'idCard': message = `${file.name}未检测到身份证或无法识别`; break
          case 'receipt': message = `${file.name}未检测到票据或无法识别`; break
        }
        return this.$message.warning(message)
      }
      // 找到扫描原件对应的控件的情况下才进行赋值操作
      if (this.targetComponent) {
        // 表格子控件的情况
        if (this.isTableComponent) {
          let columnId = this.component.properties.ocr.rules.originFileId.split('+')[1]
          content.forEach(data => {
            if (this.updateIndex >= this.targetComponent.value.length) {
              this.updateIndex = this.targetComponent.value.length
              // 更新的行超过现有行数时,需要先新增一行
              this.targetComponent.addRow()
            }
            this.targetComponent.updateChildValue(columnId, `${name},${url}`, this.updateIndex)
            Object.keys(data).forEach(key => {
              if (!this.component.properties.ocr.rules[key]) {
                return false
              }
              this.targetComponent.updateChildValue(this.component.properties.ocr.rules[key].split('+')[1], data[key], this.updateIndex)
            })
            this.updateIndex += 1
          })
        } else {
          // 非表格子控件的情况
          if (['rc-upload', 'rc-file'].includes(this.targetComponent.component.componentType)) {
            this.update({
              value: `$.$${name},${url}`,
              archiveColumnId: this.component.properties.ocr.rules.originFileId
            })
            // 更新绑定的扫描原件fileLists
            this.$nextTick(() => {
              this.targetComponent.initFileList && this.targetComponent.initFileList()
            })
          }

          if (this.component.properties.ocr.type === 'receipt') {
            // 票据 票据对应控件不是表格的情况下更新获取到的最后一张的数据
            let lastReceipt = content[content.length - 1]
            content = []
            content.push(lastReceipt)
          }
          content.forEach(data => {
            Object.keys(data).forEach(key => {
              if (!this.component.properties.ocr.rules[key]) {
                return false
              }
              this.update({
                value: `${data[key]}`,
                archiveColumnId: this.component.properties.ocr.rules[key]
              })
            })
          })
        }
      }
    },
    // 获取识别内容
    getContent (res) {
      let content = ''
      if (res && res.length !== 0) {
        content = []
        res.forEach(item => {
          // 特殊处理一下日期格式
          if (item.billingTime) {
            // 票据的日期
            item.billingTime = item.billingTime.replace(/年|月/g, '-').replace(/日/, '')
            item.billingTime = moment(new Date(item.billingTime)).format('YYYY-MM-DD')
          } else if (item.Birth) {
            // 身份证的日期
            res[0].Birth = moment(new Date(res[0].Birth)).format('YYYY-MM-DD')
          }
          let obj = {}
          /** 注意: 如果设计 或 接口的rules key 变更,要兼容历史数据 就要在这里对key单独赋值处理 并忽略原来的key.(和通用文字的key处理方法类似) */
          Object.keys(this.component.properties.ocr.rules).forEach(key => {
            if (key === 'originFileId') {
              return false
            } else if (key === 'textContent') {
              // 通用文字存的key是textContent, 接口返的是detectedText
              obj[key] = item['detectedText']
            } else {
              obj[key] = item[key]
            }
          })
          content.push(obj)
        })
      }
      return content
    },
    getUrl () {
      // 外链表单的上传地址不同，根据路由名来更改（放在定制之前）
      if (this.$route.name === 'formRuntimeOutsideChain') {
        this.url = '/shared-api/files/uploadFilesForPublic'
      }
      if (this.component.properties.ocr.type === 'idCard') {
        this.url = '/shared-api/ocr/idCardOcr'
      } else if (this.component.properties.ocr.type === 'receipt') {
        this.url = '/shared-api/ocr/mixedInvoiceOcr'
      }
      this.eventBus.$emit('form.beforeUpload', {id: this.component.id, el: this})
      return this.url
    },
    openDialog (params) {
      this.$nextTick(() => {
        this.dialogParams = {...params}
      })
    },
    async save () {
      this.dialogParams.visable = false
      // 需要删除没有勾选的文件
      await this.deleteFile('checked')
      this.$nextTick(() => this.$refs.uploadControl.submit())
    },
    cancel () {
      this.dialogParams.visable = false
      if (this.component.properties.multiple) {
        // 取消的时候，需要把ready状态的文件删除
        this.deleteFile('ready')
      }
    },
    deleteFile (status) {
      let index
      if (status === 'ready') {
        index = this.selectFileList.list.findIndex(f => f && f.status === 'ready')
      } else {
        index = this.selectFileList.selected.findIndex(f => !f.checked)
      }
      if (index !== -1) {
        this.selectFileList.list.splice(index, 1)
        this.selectFileList.selected.splice(index, 1)
        this.deleteFile(status)
      }
    }
  },
  beforeDestroy () {
    // 如果有文件正在上传、取消上传
    let findFiles = this.fileLists.filter(f => f.loading)
    findFiles.length > 0 && findFiles.forEach(f => this.$refs.uploadControl.abort(f.file))
  },
  computed: {
    getFileList () {
      return this.selectFileList.selected.filter(f => f && f.status === 'ready') || []
    },
    getFileSize () {
      return size => {
        if (size < (1024 * 1024)) {
          return `${Math.floor((size / 1024) * 100) / 100}K`
        } else {
          return `${Math.floor((size / 1024 / 1024) * 100) / 100}M`
        }
      }
    },
    getSelectSize () {
      return this.getFileList.length ? this.getFileList.map(f => f.checked ? f.size : 0).reduce((x, y) => x + y) / 1024 / 1024 : 0
    },
    getNoUploadFile () {
      return this.getFileList.length ? this.getFileList.filter(f => f.size >= this.maxSize).length : 0
    }
  }
}
</script>

<style lang="scss">
  .el-form-item.hidden{
    .el-form-item__label{
      display: none;
    }
  }
  .rc-ocr-runtime {
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .rc-ocr-control {
        width: 61px;
        .el-upload {
          .upload-button {
            & > span {
              text-decoration: underline;
            }
          }
        }
      }
    }

    i.el-icon-upload {
      color: #3a8ee6;
    }

    .el-upload {
      text-align: left;

      .el-upload-dragger {
        width: 250px;
        height: 150px;
      }
    }

    .el-form-item__content {
      .el-form-item__error {
        padding-top: 4px;
      }
    }
    .el-form-item__content:before{
      content: none;
    }
    .el-dropdown-link {
      cursor: pointer;

      &:hover {
        color: #54ABF1;
      }
    }

    .el-icon-circle-close {
      color: red;
      opacity: 0;
      margin-left: 20px;
    }

    .item {
      &:hover {
        .el-icon-circle-close {
          opacity: 1;
        }
      }
    }
  }
  .rc-ocr-dialog {
    .el-dialog {
      .el-dialog__body {
        padding: 15px 15px;
        & > .hint {
          padding: 15px 33px;
          line-height: 20px;
          .file-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: 200px;
            vertical-align: bottom;
          }
        }
        .file-select-list {
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #EBEBEB;
            font-size: 13px;
            color: #323232;
            padding-bottom: 5px;
            .right {
              text-align: center;
              width: 80px;
            }
            .left {
              padding-left: 40px;
            }
          }
          .file-content {
            color: #323232;
            height: 202px;
            overflow: auto;
            .item {
              padding: 0 10px 0 5px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 30px;
              line-height: 30px;
              .file-name {
                width: 300px;
                .name {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  display: inline-block;
                  vertical-align: bottom;
                  width: 300px;
                  cursor: pointer;
                  .el-checkbox {
                    .el-checkbox__label {
                      color: #323232;
                    }
                    .el-checkbox__inner {
                      border-radius: 2px;
                      background-color: #fff;
                      border-color: #C2C3C4;
                      &:after {
                        border-color: #55ACF1;
                      }
                    }
                    .is-checked {
                      .el-checkbox__inner {
                        border-color: #55ACF1;
                      }
                    }
                  }
                }
                .name-hint {
                  width: 180px;
                }
              }
              .size {
                width: 75px;
                text-align: right;
              }
            }
            .checked-item {
              background-color: #f7fbfe;
            }
          }
          .file-footer {
            border-top: 1px solid #EBEBEB;
            padding-top: 10px;
          }
        }
      }
      .el-dialog__footer {
        padding-top: 0;
        .dialog-footer {
          .hint-button {
            .el-button {
              width: 104px;
              height: 30px;
              border: 1px solid rgba( 84, 171, 241, 1);
              border-radius: 4px;
              padding: 0;
              color: #54ABF1;
            }
          }
          .select-file {
            .el-button {
              padding: 0;
              width: 104px;
              height: 30px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-ocr.vue